const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const SpringClickGroup = require('./spring-click-group.react');
const createReactClass = require('create-react-class');
import warning from 'warning';

const TabPanel = createReactClass({

  propTypes: {
    tabs: PropTypes.arrayOf(PropTypes.shape({
      children: PropTypes.node.isRequired,
      key: PropTypes.string.isRequired,
    })),
    children: PropTypes.node,
    selectedIndex: PropTypes.number.isRequired,
    withBorder: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
  },

  mixins: [PureRenderMixin],

  getDefaultProps() {
    return {
      withBorder: true,
    };
  },

  _onChange(index) {
    if (index !== this.props.selectedIndex) {
      this.props.onChange(index);
    }
  },

  render() {
    const { children, tabs, selectedIndex, withBorder } = this.props;

    const tabsDisplay = children ? React.Children.map(children, (child, i) => {
      return React.cloneElement(child, {
        selected: i === selectedIndex,
        onClick: this._onChange.bind(this, i),
      });
    }) : tabs.map((map, i) => {
      const tabClasses = classNames({
        'TabPanel-tab': typeof map.children === 'string',
        'is-selected': i === selectedIndex,
      });

      return (
        // TODO(fn-bind): replace with cached function
        <div key={ map.key } onClick={ this._onChange.bind(this, i) } className={ tabClasses }>
          { map.children }
        </div>
      );
    });

    const displayClasses = classNames('TabPanel', {
      'TabPanel--withBorder': withBorder,
    });

    return (
      <section className={ displayClasses }>
        { tabsDisplay }
      </section>
    );
  },
});

/**
 * SpringTextTab works with TabPanel and adds additional styling to
 * prevent the bold selected state from changing the position
 * of neighboring tabs to the right. It uses an ::after pseudo
 * element to render either the string placeholder or string children
 * with space already reserved but hidden via css.
 */
const SpringTextTab = ({ selected, children, placeholder, ...passedProps }) => {
  warning(
    typeof children === 'string' || typeof placeholder === 'string',
    'Either `children` or `placeholder` should be specified as a string that can be used to compute tab width',
  );

  const classes = classNames('SpringTextTab', {
    'SpringTextTab--selected': selected,
  });

  return (
    <SpringClickGroup.Item>
      <div className={ classes } data-placeholder={ placeholder || children } { ...passedProps }>
        { children }
      </div>
    </SpringClickGroup.Item>
  );
};
SpringTextTab.propTypes = {
  node: PropTypes.node,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

module.exports = TabPanel;
module.exports.SpringTextTab = SpringTextTab;
